import config from "./config";

export const APP_VERSION = config.appVersion;

//common config
export const WEBNAME = config.webName;
export const ADDRESS = config.address;
export const EMAIL = config.email;
export const MOBILE = config.mobile;
export const WHATSAPP = config.whatsapp;
export const NO_IMAGE = config.noImage;
export const DEVS_SITE = config.devsSite;

//keys
export const SESSION_STORAGE_KEY = config.sessionStorageKey;
export const PANEL_STORAGE_KEY = config.panelStorageKey;
export const BILLING_LAYOUT_KEY = config.BILLING_LAYOUT_KEY;
export const BILL_TYPE_KEY = config.BILL_TYPE_KEY;
export const PANEL_VIEW_KEY = config.PANEL_VIEW_KEY;
export const KOT_PRINTER_SERVER = config.kotPrinterServer;
export const WHATSAPP_GATEWAY = config.whatsappGateway;

//env config
export const WEB_URL = config.webLink;
export const SERVER = config.server;
export const SERVER_API = config.serverapi;
export const IMAGE_URL = config.imagepath;

//system route
export const ROUTE = {
  //web route
  login: config.login,
  loginSuccess: config.loginSuccess,
  forgotPassword: config.forgotPassword,

  //system route
  dashboard_overview: config.dashboard_overview,
  sales_billing: config.sales_billing,
  sales_return: config.sales_return,
  sales_history: config.sales_history,
  sales_expenses: config.sales_expenses,
  sales_cheques: config.sales_cheques,
  sales_quotation: config.sales_quotation,
  product_manage: config.product_manage,
  stock_adjustment: config.stock_adjustment,
  purchase_manage: config.purchase_manage,
  raw_material_manage: config.raw_material_manage,
  raw_material_purchase: config.raw_material_purchase,
  recipe_manage: config.recipe_manage,
  production_manage: config.production_manage,
  stock_transfer: config.stock_transfer,
  supplier_manage: config.supplier_manage,
  customer_manage: config.customer_manage,
  customer_credits: config.customer_credits,
  customer_ledger: config.customer_ledger,
  supplier_ledger: config.supplier_ledger,
  report_sales: config.report_sales,
  report_inventory: config.report_inventory,

  employee_manage: config.employee_manage,
  attendance_manage: config.attendance_manage,
  payroll_manage: config.payroll_manage,
  leave_manage: config.leave_manage,
  user_manage: config.user_manage,
  store_manage: config.store_manage,

  repair_jobs: config.repair_jobs,
  monthly_attendance_sheet: config.monthly_attendance_sheet,
  store_live_tracking: config.store_live_tracking,
  barcode_editor: config.barcode_editor,
  access_policies: config.access_policies,
  bank_manage: config.bank_manage,
  whatsapp_chatbot: config.whatsapp_chatbot,
  online_orders: config.online_orders,
  web_info: config.web_info,
  system_admin_tenants: config.system_admin_tenants,
};

export const REPORT = {
  sales_ledger: config.report.sales_ledger,
  item_profit: config.report.item_profit,
  cash_flow: config.report.cash_flow,
  cheques: config.report.cheques,
  discounts: config.report.discounts,
  non_cash_payments: config.report.non_cash_payments,
  employee_performance: config.report.employee_performance,
  sign_off_list: config.report.sign_off_list,
  sign_off_detail: config.report.sign_off_detail,
  product_stock: config.report.product_stock,
  expiring_items: config.report.expiring_items,
  purchases: config.report.purchases,
  purchased_products: config.report.purchased_products,
  returned_items: config.report.returned_items,
  sold_items: config.report.sold_items,
};

//commons
export const APPLOGO = config.appLogo;
export const SIGNIN_BG = config.signInBg;
export const PAGE_SIZE = 10;
export const DEBOUNCED_SEARCH_QUERY = 300;
export const MIN_PASSWORD_LENGTH = 4;
export const UNAUTHORIZED_EVENT = "auth:unauthorized";

// System Config Cache Constants
export const SYSTEM_CONFIG_CACHE_KEY = "system_config_cache";
export const SYSTEM_CONFIG_CACHE_TS_KEY = "system_config_cache_ts";
export const SYSTEM_CONFIG_CACHE_DURATION = 24 * 60 * 60 * 1000;

